<template>
    <div class="send-web-notification-config">
        <div class="config-field">
            <label>{{ $t("taskModuleRules.notificationMessage") }}</label>
            <div class="input-with-variables">
                <a-textarea
                    v-model="localConfig.message"
                    :placeholder="$t('taskModuleRules.notificationMessageWithDynamicVariables')"
                    :rows="3"
                    @change="emitChange"
                />
                <a-button type="link" size="small" @click="showVariablesPicker = true">
                    <i class="material-icons">code</i>
                    {{ $t("taskModuleRules.variables") }}
                </a-button>
            </div>
            <small>
                {{ $t("taskModuleRules.dynamicVariablesExample") }}
            </small>
        </div>

        <div class="config-field">
            <label>{{ $t("taskModuleRules.userType") }}</label>
            <a-radio-group v-model="localConfig.userType" @change="emitChange" button-style="solid">
                <a-radio-button value="static">{{ $t("taskModuleRules.staticUsers") }}</a-radio-button>
                <a-radio-button value="dynamic">{{ $t("taskModuleRules.dynamic") }}</a-radio-button>
            </a-radio-group>
        </div>

        <div v-if="localConfig.userType === 'static'" class="config-field">
            <label>{{ $t("taskModuleRules.users") }}</label>
            <a-select
                v-model="localConfig.userStatic"
                mode="multiple"
                :placeholder="$t('taskModuleRules.selectUsers')"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option
                    v-for="user in users"
                    :key="user._id"
                    :value="user._id"
                >
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>

        <div v-if="localConfig.userType === 'dynamic'" class="config-field">
            <label>{{ $t("taskModuleRules.dynamicUsers") }}</label>
            <a-select
                v-model="localConfig.userDynamic"
                mode="multiple"
                :placeholder="$t('taskModuleRules.selectDynamicUser')"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option value="task_owner">{{ $t("taskModuleRules.taskOwner") }}</a-select-option>
                <a-select-option value="task_assignees">{{ $t("taskModuleRules.taskAssignees") }}</a-select-option>
                <a-select-option value="task_followers">{{ $t("taskModuleRules.taskFollowers") }}</a-select-option>
                <a-select-option value="task_collaborators">{{ $t("taskModuleRules.taskCollaborators") }}</a-select-option>
            </a-select>
        </div>

        <DynamicVariablesPicker
            v-if="showVariablesPicker"
            :visible="showVariablesPicker"
            @close="showVariablesPicker = false"
            @select="insertVariable"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
import DynamicVariablesPicker from "./DynamicVariablesPicker.vue";

export default {
    name: "SendWebNotificationConfig",
    components: {
        DynamicVariablesPicker
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: {
                message: '',
                userType: 'dynamic',
                userStatic: [],
                userDynamic: []
            },
            showVariablesPicker: false
        };
    },
    computed: {
        ...mapState({
            users: state => state.user.users.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        insertVariable(variable) {
            this.localConfig.message += ` {{${variable}}}`;
            this.emitChange();
        }
    }
};
</script>

<style lang="scss" scoped>
.send-web-notification-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }

        .input-with-variables {
            display: flex;
            gap: 8px;
            align-items: flex-start;

            .ant-textarea {
                flex: 1;
            }
        }
    }
}
</style>
